import styled from "@emotion/styled/macro";
import React, { useState } from "react";

//import Button from "./Button";

//import logoIcon from "../res/favicon-32x32.png";
import menuIcon from "../res/i_hamburger.svg";
//import signInIcon from "../res/i_signin_dark.svg";
import Menu from "../App/Menu";
import { Switch, Route } from "react-router";
import { Link } from "react-router-dom";
import { ICachedData } from "../ApiService";

interface IProps {
  cachedData: ICachedData;
  bobblehead?: any;
  isSignedIn: boolean;
  showPlaceholder?: boolean;
  showSignInDialog: () => void;
}

const Root = styled<"header", { menuIsOpen: boolean }>("header")`
  position: absolute;
  width: 100%;
  top: 0;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  z-index: ${({ menuIsOpen }) => (menuIsOpen ? 2 : 1)};
`;

const Actions = styled<"div", { visible: boolean }>("div")`
  flex-shrink: 0;
  display: flex;
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
`;

const Logo = styled(Link)`
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  background-size: contain;
  position: relative;
`;

//background: url(${logoIcon}) no-repeat center top transparent;

const MenuButton = styled("button")`
  width: 44px;
  height: 44px;
  border: none;
  background: url(${menuIcon}) no-repeat center center transparent;
  background-size: 20px auto;
`;

/*const SignInButton = styled(Button)`
  margin-right: 20px;
`;*/

const PageTitle = styled("h1")`
  font-weight: normal;
  font-size: 18px;
  text-transform: uppercase;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  margin: 0 6px;
`;

export default function Header({
  cachedData,
  bobblehead,
  isSignedIn,
  showPlaceholder,
  showSignInDialog
}: IProps) {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  return (
    <Root menuIsOpen={menuIsOpen}>
      <Logo to={`/${window.location.search}`} />
      <Switch>
        <Route
          path="/collection/:bobbleheadId"
          render={({
            match: {
              params: { bobbleheadId }
            }
          }) => {
            const bobblehead = cachedData.bobbleheads[bobbleheadId];
            return (
              <PageTitle>
                {bobblehead ? bobblehead.name : "Digital Bobblehead Doll"}
              </PageTitle>
            );
          }}
        />
        <Route
          path="/collection"
          render={() => <PageTitle>My Collection</PageTitle>}
        />
        <Route
          path="/"
          render={() =>
            !menuIsOpen && bobblehead ? (
              <PageTitle>{bobblehead.name}</PageTitle>
            ) : null
          }
        />
      </Switch>
      {!showPlaceholder && (
        <Actions visible={!menuIsOpen}>
          {/*{!bobblehead && !isSignedIn && (
            <SignInButton
              iconUrl={signInIcon}
              onClick={() => {
                showSignInDialog();
              }}
            >
              Sign In
            </SignInButton>
            )} */}
          <MenuButton
            onClick={() => {
              setMenuIsOpen((isOpen: boolean) => !isOpen);
            }}
          />
        </Actions>
      )}
      {menuIsOpen && (
        <Menu
          isSignedIn={isSignedIn}
          onClose={() => setMenuIsOpen(false)}
          showSignInDialog={showSignInDialog}
        />
      )}
    </Root>
  );
}
